import React from 'react'

const Nodejs_Coding_Pratice_6 = () => {
  return (
    <div>
      <h1>Coding Pratice 6</h1>
    </div>
  )
}

export default Nodejs_Coding_Pratice_6
